import { useOnlineStatus } from '../hooks/useOnlineStatus';
import { Cloud, CloudOff, Check, AlertCircle, Loader2, WifiOff } from 'lucide-react';

export function Header({ syncStatus, backendAvailable }) {
  const isOnline = useOnlineStatus();

  const getStatusInfo = () => {
    if (!isOnline) return { label: 'Sem Internet', color: 'red', icon: <WifiOff size={14} /> };
    if (!backendAvailable) return { label: 'Servidor offline', color: 'red', icon: <CloudOff size={14} /> };
    
    switch (syncStatus) {
      case 'saving':
        return { label: 'Salvando...', color: 'blue', icon: <Loader2 size={14} className="animate-spin" /> };
      case 'loading':
        return { label: 'Carregando...', color: 'blue', icon: <Loader2 size={14} className="animate-spin" /> };
      case 'saved':
        return { label: 'Salvo ✓', color: 'green', icon: <Check size={14} /> };
      case 'error':
        return { label: 'Erro ao salvar', color: 'red', icon: <AlertCircle size={14} /> };
      default:
        return { label: 'Conectado', color: 'green', icon: <Cloud size={14} /> };
    }
  };

  const status = getStatusInfo();
  
  const colorClasses = {
    blue: 'bg-blue-500/20 text-blue-400 border-blue-500/30',
    green: 'bg-green-500/20 text-green-400 border-green-500/30',
    red: 'bg-red-500/20 text-red-400 border-red-500/30'
  };

  return (
    <header 
      data-testid="header"
      className="fixed top-0 w-full h-16 bg-[var(--bg-header)] flex items-center justify-between px-4 z-50 shadow-md theme-transition"
    >
      <div className="flex items-center gap-3">
        <img 
          src="/logo192.png" 
          alt="Dealer Manager" 
          className="w-10 h-10 rounded-lg"
        />
        <div>
          <h1 className="text-lg font-bold tracking-tight text-[var(--accent-sky)]">
            Dealer Manager
          </h1>
          <p className="text-xs text-[var(--text-muted)]">Gestão de Revendas</p>
        </div>
      </div>
      
      {/* Status Indicator */}
      <div className={`flex items-center gap-1.5 px-3 py-1.5 rounded-full text-[10px] font-medium border ${colorClasses[status.color]}`}>
        {status.icon}
        <span>{status.label}</span>
      </div>
    </header>
  );
}
